import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGES, setLanguage } from "@/i18n";

export const LanguagePicker = ({ compact = false }) => {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const current = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  return (
    <div className={compact ? "" : "px-3 py-2"}>
      <button data-testid="language-picker-btn" onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center gap-2 text-left text-sm font-bold text-slate-300 hover:text-white transition-colors">
        <span className="text-base">🌍</span>
        <span className="flex-1">{t("common.language")}</span>
        <span className="text-[11px] text-slate-400">{current.flag} {current.label}</span>
      </button>
      {open && (
        <div data-testid="language-picker-grid" className="grid grid-cols-2 gap-1 mt-2">
          {LANGUAGES.map((l) => (
            <button key={l.code} data-testid={`lang-${l.code}`}
              onClick={() => { setLanguage(l.code); setOpen(false); }}
              className={`flex items-center gap-1.5 rounded-lg px-2 py-1.5 text-[11px] font-bold transition-colors ${i18n.language === l.code ? "bg-emerald-500/25 text-emerald-200" : "bg-slate-800/60 text-slate-300 hover:bg-slate-700/70"}`}>
              <span>{l.flag}</span><span className="truncate">{l.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
